export default {
	pageHeight: 100,
	footerHeight: 60,
	statusBarHeight: 0,
	titleBarHeight: 50,
	Source: 0, //4app
	development: false, //开放中可见
	version_number: 0,
	chatMsgCheckbox: false,
}